import(/* webpackMode: "eager" */ "/www/wwwroot/dmt-courtbook/src/app/admin/layout.tsx");
